import { useSelector } from 'react-redux';

import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import * as vehicleProtectionSelectors from '@makemydeal/dr-dash-store/selectors/vehicleProtectionSelectors';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { PROTECTION_PRODUCTS } from '../../../../../constants';
import { ReadOnlyLinkRow } from '../../ReadOnlyLinkRow';

export const ProtectionProductsRow = () => {
    const { totalProductPrice } = useSelector(vehicleProtectionSelectors.getVppSummary);

    return (
        <ReadOnlyLinkRow
            rowKey="protectionProducts"
            label={PROTECTION_PRODUCTS}
            value={formatNumberAndCents(totalProductPrice)}
            tab={DealTabs.PROTECTION}
        />
    );
};
